import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import InputMask from 'react-input-mask';
import { Modal } from 'react-bootstrap';
import getLocale from '../../i18n/getLocale';

class ScheduleBasesEdit extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      blocked_approval: 0,
      id: '',
      date_start: '',
      date_finish: '',
      schedule_grade: {},
      schedule: {},
      schedule_grades: [],
      modal: false,
      verification: 0,
      signing: 0,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.edit = this.edit.bind(this);
    this.loadData = this.loadData.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.getInfoEscala = this.getInfoEscala.bind(this);
    this.verify = this.verify.bind(this);
    this.approve = this.approve.bind(this);
    this.duplicate = this.duplicate.bind(this);
    this.export = this.export.bind(this);
    this.blockApproval = this.blockApproval.bind(this);
    this.unblockApproval = this.unblockApproval.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  } 

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData(1));
    }
  }

  loadData (first_load) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/escala/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/sigla/modelos');
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.main.id,
            blocked_approval: responseJson.data.main.blocked_approval,
            date_start: responseJson.data.main.date_start_str,
            date_finish: responseJson.data.main.date_finish_str,
            schedule: responseJson.data,
          });
        }
      }).then(() => {
      var url = config.get('api') + '/escala/base/grades/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({schedule_grades: responseJson.data});
        }
      }).then(() => {
        if(first_load === 1) {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          self.handleMessage();
        }
      }); /* Overlay */ }); /* ScheduleGrades */
    });
  }
  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/base', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  // Modal para marcar como verificada
  verify(schedule_grade_id){
    this.setState({verification: 1});
    this.getInfoEscala(schedule_grade_id);
  }

  // Modal para marcar como verificada
  confirmVerify(schedule_grade_id){
    var confirm = window.confirm(this.locale.EscalasDeBase.EditarEscalaDeBase.trocarStatusParaVerificada);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var datasave = {
        id: schedule_grade_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/verificar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.loadData(0);
          self.closeModal();
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  // Modal para marcar como verificada
  confirmSign(schedule_grade_id){
    var confirm = window.confirm(this.locale.EscalasDeBase.EditarEscalaDeBase.trocarStatusParaAprovada);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var datasave = {
        id: schedule_grade_id,
        type: 'base',
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/aprovar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.loadData(0);
          self.closeModal();
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  // Modal para marcar como verificada
  duplicate(schedule_grade_id){
    var confirm = window.confirm(this.locale.EscalasDeBase.EditarEscalaDeBase.criarRevisaoDestaGrade);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var datasave = {
        id: schedule_grade_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/base/grade/duplicar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.loadData(0);
          self.closeModal();
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  // Modal para marcar como verificada
  approve(schedule_grade_id){
    this.setState({signing: 1});
    this.getInfoEscala(schedule_grade_id);
  }

  // Fecha modal
  closeModal(event){
    this.setState({modal: false, grade: [], grade_alternate: [], schedule_grade: {}, verification: 0, signing: 0});
  }

  // gero os dados do modal de visualização da escala
  getInfoEscala (event) {
    if (typeof event.currentTarget !== 'undefined') {
      var schedule_grade_id = event.currentTarget.value;
    } else {
      var schedule_grade_id = event;
    }
    var self = this;
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/escala/grade/base/registros/' + schedule_grade_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/sigla/modelos');
        if (responseJson.status === 'success') {
          self.setState({grade: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/escala/grade/info/' + schedule_grade_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({schedule_grade: responseJson.data.schedule_grade});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.setState({modal: true});
      }); /* Overlay */ }); /* info grade */
    });
  }

  blockApproval(event) {
    var self = this;
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/bloquear/' + self.state.id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({blocked_approval: responseJson.data.blocked_approval});
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      })
    });
  }

  unblockApproval(event) {
    var self = this;
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/desbloquear/' + self.state.id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({blocked_approval: responseJson.data.blocked_approval});
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      })
    });
  }


  export(event) {
    var schedule_grade_id = event.currentTarget.value;
    var self = this;
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/exportacao/escala/base/' + schedule_grade_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        window.open(config.get('cdn') + '/tmp/' + responseJson.data);
      })
    });
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.EscalasDeBase.EditarEscalaDeBase.titulo}</h3>
      <Link to="/escalas/base" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      {this.state.blocked_approval === 0 ? 
        <button onClick={self.blockApproval} className="pull-right btn btn-danger button-inline" value={self.state.id}><i className="fa fa-fw fa-warning"></i> {this.locale.EscalasDeBase.EditarEscalaDeBase.botaoBloquearEscala}</button>
        : 
        <button onClick={self.unblockApproval} className="pull-right btn btn-success button-inline" value={self.state.id}><i className="fa fa-fw fa-warning"></i> {this.locale.EscalasDeBase.EditarEscalaDeBase.botaoDesbloquearEscala}</button>
      }
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.edit}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.EscalasDeBase.EditarEscalaDeBase.formulario.DataInicial}:</label>
              <InputMask value={this.state.date_start}  maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.EscalasDeBase.EditarEscalaDeBase.formulario.DataFinal}:</label>
              <InputMask value={this.state.date_finish}  maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" />
            </div>
          </div>
        </div>
        <div>
          <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.general.salvarEdicao}</button>
        </div> 
      </form>
      <hr/>
      <h3 className="page-title">{this.locale.EscalasDeBase.EditarEscalaDeBase.tituloGrades}</h3>
      <hr/>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th className="col-md-3 text-center">{this.locale.EscalasDeBase.EditarEscalaDeBase.tabelaGrades.Revisao}</th>
            <th className="col-md-3 text-center">{this.locale.EscalasDeBase.EditarEscalaDeBase.tabelaGrades.Status}</th>
            <th className="col-md-6 text-center">{this.locale.EscalasDeBase.EditarEscalaDeBase.tabelaGrades.Acoes}</th>
          </tr>
        </thead>
        <tbody id="suppliers-certifications">
          {Object.keys(self.state.schedule_grades).map(function(k) {
            return (
              <tr>
                <td className="text-center">{self.state.schedule_grades[k].revision}</td>
                <td className="text-center">{self.state.schedule_grades[k].status_str}</td>
                <td className="text-center">
                  {(self.state.schedule_grades[k].status === 'draft') ?  
                    <div>
                      <button className="btn btn-default button-inline" onClick={self.getInfoEscala} value={self.state.schedule_grades[k].id}><i className="fa fa-fw fa-eye"></i> {self.locale.general.exportar}</button>
                      <button onClick={self.export} className="btn btn-success button-inline" value={self.state.schedule_grades[k].id}><i className="fa fa-download"></i> {self.locale.general.exportarPDF}</button>
                      <Link to={"/escala/base/grade/" + self.state.schedule_grades[k].id} className="btn btn-success button-inline" ><i className="fa fa-fw fa-pencil"></i> {self.locale.general.editar}</Link>
                      <button className="btn btn-primary button-inline" value={self.state.schedule_grades[k].id} onClick={() => self.verify(self.state.schedule_grades[k].id)}><i className="fa fa-fw fa-check"></i> {self.locale.EscalasDeBase.EditarEscalaDeBase.botaoMarcarComoVerificada}</button>
                    </div>
                    : ''
                  }
                  {(self.state.schedule_grades[k].status === 'verified') ?  
                    <div>
                      <button className="btn btn-default button-inline" onClick={self.getInfoEscala} value={self.state.schedule_grades[k].id}><i className="fa fa-fw fa-eye"></i> {self.locale.general.exportar}</button>
                      <button onClick={self.export} className="btn btn-success button-inline" value={self.state.schedule_grades[k].id}><i className="fa fa-download"></i> {self.locale.general.exportarPDF}</button>
                      <button className="btn btn-primary button-inline" value={self.state.schedule_grades[k].id} onClick={() => self.approve(self.state.schedule_grades[k].id)}><i className="fa fa-fw fa-check"></i> {self.locale.EscalasDeBase.EditarEscalaDeBase.botaoMarcarComoAprovada}</button>
                    </div>
                    : ''
                  }
                    {(self.state.schedule_grades[k].status === 'approved') ?  
                    <div>
                      <button className="btn btn-default button-inline" onClick={self.getInfoEscala} value={self.state.schedule_grades[k].id}><i className="fa fa-fw fa-eye"></i> {self.locale.general.exportar}</button>
                      <button onClick={self.export} className="btn btn-success button-inline" value={self.state.schedule_grades[k].id}><i className="fa fa-download"></i> {self.locale.general.exportarPDF}</button>
                      <button className="btn btn-primary button-inline" value={self.state.schedule_grades[k].id} onClick={() => self.duplicate(self.state.schedule_grades[k].id)}><i className="fa fa-fw fa-refresh"></i> {self.locale.EscalasDeBase.EditarEscalaDeBase.botaoCriarRevisao}</button>
                    </div>
                    : ''
                  }
                    {(self.state.schedule_grades[k].status === 'deprecated') ?  
                    <div>
                      <button className="btn btn-default button-inline" onClick={self.getInfoEscala} value={self.state.schedule_grades[k].id}><i className="fa fa-fw fa-eye"></i> {self.locale.general.exportar}</button>
                      <button onClick={self.export} className="btn btn-success button-inline" value={self.state.schedule_grades[k].id}><i className="fa fa-download"></i> {self.locale.general.exportarPDF}</button>
                    </div>
                    : ''
                  }
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  </div>
  <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">{this.locale.EscalasDeBase.EditarEscalaDeBase.tituloRevisao} {self.state.schedule_grade.revision} - {this.state.schedule.name}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      {(self.state.verification === 1) ?  
        <div>
          <button className="btn btn-primary btn-block btn-lg" onClick={() => self.confirmVerify(self.state.schedule_grade.id)}><i className="fa fa-fw fa-check"></i> {self.locale.EscalasDeBase.EditarEscalaDeBase.botaoConfirmarMudancaDeStatusParaVerificada}</button>
          <hr/>
        </div> 
      : ""
      }
      {(self.state.signing === 1) ?  
        <div>
          <button className="btn btn-primary btn-block btn-lg" onClick={() => self.confirmSign(self.state.schedule_grade.id)}><i className="fa fa-fw fa-check"></i> {self.locale.EscalasDeBase.EditarEscalaDeBase.botaoAprovarEscala}</button>
          <hr/>
        </div> 
      : ""
      }
      {(this.state.grade === null || typeof this.state.grade === 'undefined') ?  <div></div> 
      : 
      <table className="table table-bordered table-stripped table-hover">
        <thead>
          <tr>
            <th className="text-center">{this.locale.EscalasDeBase.EditarEscalaDeBase.tabela.Tripulante}</th>
            <th className="text-center">{this.locale.EscalasDeBase.EditarEscalaDeBase.tabela.Designacao}</th>
            <th className="text-center">{this.locale.EscalasDeBase.EditarEscalaDeBase.tabela.Base}</th>
            <th className="text-center">{this.locale.EscalasDeBase.EditarEscalaDeBase.tabela.DataInicial}</th>
            <th className="text-center">{this.locale.EscalasDeBase.EditarEscalaDeBase.tabela.DataFinal}</th>
          </tr>
        </thead>
        <tbody id="suppliers-certifications">
          {Object.keys(self.state.grade).map(function(k) {
            return (
              <tr>
                <td className="text-center">{self.state.grade[k].staff.name}</td>
                <td className="text-center">{self.state.grade[k].designation.name}</td>
                <td className="text-center">{self.state.grade[k].base.name}</td>
                <td className="text-center">{self.state.grade[k].date_start_str}</td>
                <td className="text-center">{self.state.grade[k].date_finish_str}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      }
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default ScheduleBasesEdit;



// WEBPACK FOOTER //
// ./src/Components/ScheduleBases/ScheduleBasesEdit.js